import getHeader from '@ahmdigital/logic/lib/content/offers/unqualified/get-header';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { OfferByIdentifierQuery } from '../../../../types/__codegen__/sanity/graphql';
import getOfferImage from '../../../../components/offers/utils/get-offer-image';

const deriveMetaDataFromOffer = (offer: OfferByIdentifierQuery['allOffer'][0] | null) => {
  const header = getHeader(offer);
  // @ts-expect-error - Logic types need fixing for correct portable text type
  const title = portableTextToPlain(header);
  const description = offer?.offerTypes?.[0]?.summary;
  const socialImageSrc = getOfferImage(offer)?.src;
  return {
    description,
    socialImageSrc,
    title,
  };
};

export default deriveMetaDataFromOffer;
